import { Flags, ValueOfKey } from '../../utils-types';

export const SIGN_UP_PAYMENT_RESULT_TYPE = {
  REGISTRATION: 'REGISTRATION',
  REACTIVATION: 'REACTIVATION',
} as const;

export type SignUpPaymentResultType = ValueOfKey<typeof SIGN_UP_PAYMENT_RESULT_TYPE>;
export type SignUpPaymentResultTypeKeys = keyof typeof SIGN_UP_PAYMENT_RESULT_TYPE;
export type SignUpPaymentResultTypeFlags = Flags<SignUpPaymentResultTypeKeys>;
